var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "8px",
    viewBox: "0 0 35 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ears") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Humanuculus",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.195858829
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy-29",
    transform: "translate(-198.000000, -61.000000)",
    fill: "#1E428A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Front-Body---Selections",
    transform: "translate(175.074098, 42.681852)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5229992,22.4314088 C23.5229992,20.3846064 24.6737391,18.025271 25.2998205,18.4988417 C25.7172082,18.8145556 26.2996519,21.3149068 27.0471518,25.9998955 C24.6977167,24.9854393 23.5229992,23.7959437 23.5229992,22.4314088 Z M57.5471518,22.4314088 C57.5471518,23.7959437 56.3724342,24.9854393 54.0229992,25.9998955 C54.770499,21.3149068 55.3529428,18.8145556 55.7703304,18.4988417 C56.3964118,18.025271 57.5471518,20.3846064 57.5471518,22.4314088 Z",
    id: "Ears"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEars);
export default __webpack_public_path__ + "static/media/Ears.1af66a601a9d5281880450f376007436.svg";
export { ForwardRef as ReactComponent };